import { observable, action, computed, createTransformer, reaction } from "mobx";
import {arrayToString, getByAtribute, stringToArray} from "../../../utils/formatar";
import GDVService from "../../../services/GDVService";
import EmpresaGloboService from "../../../services/EmpresaGloboService";
import CargoService from "../../../services/CargoService";

export default class GDVStore {

    @observable gdvList;
    @observable itemSelecionado;
    @observable cargos;
    @observable empresasGlobo;
    @observable cargosSemGDV;
    @observable loading;
    @observable desabilitarSelecionarCargos;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.gdvList = [];
        this.resetItemSelecionado();
        this.cargos = [];
        this.empresasGlobo = [];
        this.GDVService = new GDVService()
        this.empresaGloboService = new EmpresaGloboService();
        this.cargoService = new CargoService();
        this.cargosSalvos = [];
        this.desabilitarSelecionarCargos = true

        reaction(
            () => this.itemSelecionado.empresaGloboId,
            empresaGloboId => {
                this.carregarCargos(empresaGloboId);
            }
        );
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            empresaGlobo: {
                id: 0,
                nome: "",
                grupoSalarial: "",
                codigoFpw:0
            },
            empresaGloboId: "",
            cargos: [],
            cargoIds: "",
            cargosSalvos: [],
            tipo: "",
            percentualGdv: 0,
            ativo: true
        };
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.GDVService.list().then(response => {
                this.gdvList = response.data;
            }).catch(error => {
                console.log(error);
            }),
            this.carregarEmpresasGlobo()
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    carregarCargos(empresaGloboId) {
        this.desabilitarSelecionarCargos = true;
        if(empresaGloboId) {
            this.cargoService.listSemGDV(empresaGloboId).then(response => {
                this.cargos = response.data;
                for (let i = 0; i < this.cargosSalvos.length; i++) {
                    this.cargos.push(this.cargosSalvos[i])
                }
                this.desabilitarSelecionarCargos = false;
            }).catch(error => {
                this.cargos = [];
                console.log(error);
                this.desabilitarSelecionarCargos = true;
            })
        }
    }

    carregarEmpresasGlobo() {
        this.empresaGloboService.list().then(response => {
            this.empresasGlobo = response.data;
        }).catch(error => {
            console.log(error);
        })
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    setEmpresaGloboId(value) {
        if(!value) {
            this.desabilitarSelecionarCargos = true;
            this.itemSelecionado.cargoIds = "";
        }
        this.itemSelecionado.empresaGloboId = value;
    }

    setCargoIds(value) {
        this.itemSelecionado.cargoIds = value;
    }

    setTipo(value) {
        this.itemSelecionado.tipo = value;
    }

    setPercentualGdv(value) {
        this.itemSelecionado.percentualGdv = value;
    }

    setLista(value) {
        this.gdvList = value;
    }

    preencherModal(row){
        if(row) {
            this.cargosSalvos = row.cargos;
            row.cargoIds = arrayToString(row.cargos, "id", true);
            row.empresaGloboId = row.empresaGlobo.id;
            this.itemSelecionado = Object.assign({}, row);
            this.carregarCargos(this.itemSelecionado.empresaGloboId);
        } else {
            this.cargosSalvos = [];
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.gdvList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        this.itemSelecionado.empresaGlobo = getByAtribute(this.empresasGlobo, this.itemSelecionado.empresaGloboId, "id");
        this.itemSelecionado.cargos = stringToArray(this.cargos, this.itemSelecionado.cargoIds, "id");

        return this.GDVService.edit(this.itemSelecionado.id, this.itemSelecionado).then(response => {
            this.gdvList[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        this.itemSelecionado.empresaGlobo = getByAtribute(this.empresasGlobo, this.itemSelecionado.empresaGloboId, "id");
        this.itemSelecionado.cargos = stringToArray(this.cargos, this.itemSelecionado.cargoIds, "id");

        return this.GDVService.save(this.itemSelecionado).then(response => {
            this.gdvList.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.gdvList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.GDVService.delete(this.itemSelecionado.id).then(response => {
            this.gdvList.splice(tabelaIndex, 1);
            modal.toggleModal()
        })
    }


}